import React from 'react';

export default function SharpIcon({
  className,
  onClick,
  fill,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  fill?: string;
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill || '#6C757D'}
    >
      <path d="M16.018 3.81494L15.232 7.99994H10.266L10.982 4.18494L9.018 3.81494L8.232 7.99994H4V9.99994H7.857L7.106 13.9999H3V15.9999H6.731L6.017 19.8049L7.982 20.1739L8.766 15.9999H13.732L13.018 19.8049L14.983 20.1739L15.766 15.9999H20V13.9999H16.141L16.892 9.99994H21V7.99994H17.267L17.983 4.18494L16.018 3.81494ZM14.106 13.9999H9.141L9.892 9.99994H14.858L14.106 13.9999Z" />
    </svg>
  );
}
